var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.023,
    height: 43.022,
    viewBox: "0 0 43.023 43.022",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.bRJDsdaff{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H43.023V43.022H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bRJDsdaff",
    d: "M15.705,31.408V22.445h7.171v8.963A1.8,1.8,0,0,0,24.668,33.2h5.378a1.8,1.8,0,0,0,1.793-1.793V18.86h3.047a.889.889,0,0,0,.592-1.56L20.492,3.8a1.806,1.806,0,0,0-2.4,0L3.1,17.3a.893.893,0,0,0,.592,1.56H6.742V31.408A1.8,1.8,0,0,0,8.535,33.2h5.378A1.8,1.8,0,0,0,15.705,31.408Z",
    transform: "translate(2.221 2.651)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHeader);
export default __webpack_public_path__ + "static/media/home-header.7c5d8d3a.svg";
export { ForwardRef as ReactComponent };